import { render, staticRenderFns } from "./messengers.vue?vue&type=template&id=1647d469&"
import script from "./messengers.vue?vue&type=script&lang=js&"
export * from "./messengers.vue?vue&type=script&lang=js&"
import style0 from "./messengers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports